<template>
  <div :class="$style.box">
    <div :class="$style.title">このコンテンツをシェア</div>
    <div :class="$style.sns">
      <AtomsConsumerLink
        :url="`https://x.com/intent/tweet?url=${encode(url)}&via=TENTIAL_Inc&related=TENTIAL_Inc&text=${title}`"
        :class="[$style.icon, $style.x]"
        target="_blank"
      >
        <AtomsConsumerImage src="/images/site/interview/sns/x.svg" alt="twitterロゴ" :class="$style.logo" />
      </AtomsConsumerLink>
      <AtomsConsumerLink
        :url="`https://www.facebook.com/sharer?u=${encode(url)}`"
        :class="[$style.icon, $style.facebook]"
        target="_blank"
      >
        <AtomsConsumerImage src="/images/site/interview/sns/facebook.svg" alt="facebookロゴ" :class="$style.logo" />
      </AtomsConsumerLink>
      <AtomsConsumerLink
        :url="`http://pinterest.com/pin/create/button/?url=${encode(url)}&description=${title}`"
        :class="[$style.icon, $style.pinterest]"
        target="_blank"
      >
        <AtomsConsumerImage src="/images/site/interview/sns/pinterest.svg" alt="pinterestロゴ" :class="$style.logo" />
      </AtomsConsumerLink>
      <AtomsConsumerLink
        :url="`https://social-plugins.line.me/lineit/share?url=${encode(url)}`"
        :class="[$style.icon, $style.line]"
        target="_blank"
      >
        <AtomsConsumerImage src="/images/site/interview/sns/line.svg" alt="lineロゴ" :class="$style.logo" />
      </AtomsConsumerLink>
    </div>
  </div>
</template>
<script setup lang="ts">
type Props = {
  title: string
  url: string
}
withDefaults(defineProps<Props>(), {
  title: "",
  url: "",
})

const encode = (_url: string): string => {
  return _url ? encodeURIComponent(_url) : ""
}
</script>
<style scoped module lang="scss">
.box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 30px 1.25rem;
  border-top: 1px solid $primary-20;
  border-bottom: 1px solid $primary-20;
  @include md {
    padding: 2.5rem 0;
  }
}

.title {
  font-size: $font-size-12;
  color: $black-100;
  font-weight: normal;
  @include md {
    font-size: $font-size-15;
  }
}

.sns {
  margin-left: 2px;
  display: flex;
  gap: 0 0.5rem;
  @include md {
    gap: 0 0.75rem;
  }
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 7px 9px 8px 8px;
  width: 30px;
  height: 30px;
  @include md {
    width: 36px;
    height: 36px;
  }
  &.x {
    background-color: $share-x;
    @include md {
      .logo {
        width: 16px;
        height: 19px;
      }
    }
  }
  &.facebook {
    background-color: $share-facebook;
    padding-top: 8px;
    @include md {
      .logo {
        width: 11px;
        height: 22px;
      }
    }
  }
  &.pinterest {
    padding-top: 9px;
    background-color: $share-pinterest;
    @include md {
      padding-left: 10px;
      .logo {
        width: 18px;
        height: 23px;
      }
    }
  }
  &.line {
    padding-right: 8px;
    padding-top: 9px;
    background-color: $share-line;
    @include md {
      padding-right: 6px;
      .logo {
        width: 24px;
        height: 22.867px;
      }
    }
  }
}
</style>
